import React, { useState } from 'react';
// CSS Styles
import './Tabs.css';
import Layout from "../../Layout";
import TaskTable from './TaskTable'
import { useNavigate } from 'react-router-dom';
import {
    MyTaskData
} from '../../components/Datas';
import Summary from './Summary';

const Tabs = () => {
    const [activeTab, setActiveTab] = useState(0);

    const navigate = useNavigate();

    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const handleTabClickWorkLog = (index) => {
        setActiveTab(index);
    };

    const tasksInProgress = [
        { id: 1, name: "Task 1", status: "In Progress" },
        { id: 2, name: "Task 2", status: "In Progress" },
    ];

    const scheduledTasks = [
        // { id: 3, name: "Task 3", status: "Scheduled" },
        // { id: 4, name: "Task 4", status: "Scheduled" },
    ];

    return (
        <Layout>
            <>
                <div className="tabs-container">
                    <div className="tabs">
                        <div
                            className={`tabBackground ${activeTab === 0 ? 'active' : ''}`}
                            onClick={() => handleTabClickWorkLog(0)}
                        >
                            Table
                        </div>
                        <div
                            className={`tabBackground ${activeTab === 1 ? 'active' : ''}`}
                            onClick={() => handleTabClickWorkLog(1)}
                        >
                            Summary
                        </div>
                    </div>
                </div>

                <div className="container">
                    {activeTab === 0 && (
                        <div className="container mx-auto px-4 my-4 bg-white">
                            <TaskTable
                                data={MyTaskData.slice(0, 5)}
                                action={false}
                            />
                        </div>
                    )}
                    {activeTab === 1 && (
                        <div className="container mx-auto p-4">
                            <Summary />
                        </div>
                    )}
                </div>
            </>
        </Layout>
    );
};

export default Tabs;


